export enum DriverStatus {
  OnTime = 'ON_TIME',
  Risk = 'RISK',
  Late = 'LATE',
  Unknown = 'UNKNOWN',
}
